import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Button } from 'gu-ui-kit'
import { roundMoney } from 'utils/roundMoney'
import { formatToString } from 'utils/formatMoney'
import styles from 'modules/Forms/Billing/Billing-forms.module.scss'
import { CURRENCIES } from 'constants/app-config'

const RoundTo = ({ account = {}, onClick = () => {} }) => {
  const { t } = useTranslation(['billing'])
  const { value = null, currency } = account

  const roundedAmount = useMemo(() => roundMoney(value), [value])

  if (value === null || (value >= 0 && roundedAmount === value)) {
    return null
  }

  return (
    <Button
      variant={'primary'}
      size={'xs'}
      className={styles['billing__amount-rounding-button']}
      bgColor={'Label-Onsurface'}
      type="button"
      onClick={() => onClick(roundedAmount)}
    >
      {t('round', {
        amount: formatToString(roundedAmount, currency),
      })}
    </Button>
  )
}

RoundTo.propTypes = {
  account: PropTypes.shape({
    value: PropTypes.number,
    currency: PropTypes.oneOf(CURRENCIES),
  }),
  onClick: PropTypes.func,
}
export default RoundTo
